module.exports = __webpack_public_path__ + "static/media/de_dust2.da7ed03e.svg";